import { defineComponent, h } from 'vue';
// @ts-ignore
import { BSwitch } from 'buefy/dist/esm/switch';
import { VNodeData } from 'vue/types/vnode.d';

interface SwitchFieldProps {
  value: boolean;
  label: string;
  size?: 'is-small' | 'is-medium' | 'is-large';
  leftLabel?: boolean;
}

export const SwitchField = defineComponent<SwitchFieldProps>({
  name: 'SwitchField',
  props: ['value', 'size', 'leftLabel', 'label'],
  setup(props, context) {
    const onInput = (value: boolean) => {
      context.emit('input', value);
    };

    return function render() {
      return h(BSwitch, {
        props: {
          ...props,
          rounded: true,
        },
        on: { input: onInput },
      },
      [props.label]);
    };
  },
});

export function switchField(data: VNodeData & { props: SwitchFieldProps }) {
  return h(SwitchField, data);
}
